import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const GuardianRoute = ({ children }) => {
  const { currentUser } = useAuth();
  if (!currentUser || !currentUser.role === "guardian") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default GuardianRoute;
